module.exports = __webpack_public_path__ + "img/menu.29396cc2.svg";